import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@metarouter-private/mr-mui';

export default function BulkDeployDiffActions({ onClose }) {
  return (
    <Button onClick={onClose} data-test-id="closeDiffModal">
      Close
    </Button>
  );
}

BulkDeployDiffActions.propTypes = {
  onClose: PropTypes.func.isRequired,
};
